module.exports = "img/photo28.8bcfb7.jpg";